(function ($, document, window) {
  "use strict";

  $(function () {
    const $carousel = $(".js-carousel");

    // Init Carousel
    if ($carousel.length) {
      $(".js-carousel").each(function () {
        const sliderContainer = $(this);
        const sliderEl = $(".swiper", sliderContainer)[0];
        const slideColumns = sliderContainer
          .find(".swiper-wrapper")
          .data("columns");
        const slidesCount = sliderContainer.find(".swiper-slide").length;

        const swiper = new Swiper(sliderEl, {
          direction: "horizontal",
          loop: true,
          slidesPerView: slidesCount < 2 ? 1 : 1.1,
          breakpoints: {
            520: {
              slidesPerView: slidesCount > 2 ? 2.2 : slidesCount > 1 ? 2 : 1,
            },
            700: {
              slidesPerView: slidesCount > 2 ? 3 : slidesCount > 1 ? 2 : 1,
            },
            992: {
              slidesPerView: slidesCount < 3 ? slidesCount : 3,
            },
            1313: {
              slidesPerView: slidesCount < 4 ? slidesCount : 4,
            },
          },
          navigation: {
            nextEl: $(".js-carousel-nav-next", sliderContainer)[0],
            prevEl: $(".js-carousel-nav-prev", sliderContainer)[0],
          },
          pagination: {
            el: $(".swiper-pagination", sliderContainer)[0],
            type: "bullets",
            clickable: true,
          },
        });
      });
    }

    const ROW_SELECTOR = '.qld__section__row.qld__section__row--same-height';
    const COL_SELECTOR = '.qld__section__column';
    const COL_CONTENT_INNER_SELECTOR = '.qld__section__column__content > *';

    function equaliseRow($row) {
      // Reset heights first
      $row.find(COL_CONTENT_INNER_SELECTOR).css('height', 'auto');

      const $cols = $row.find(COL_SELECTOR);
      if ($cols.length === 0) return;

      // Group columns by visual row (based on top offset)
      const groups = [];
      const TOL = 2; // px tolerance for sub-pixel differences

      $cols.each(function () {
        const $col = $(this);
        const top = Math.round($col.offset().top);
        let group = groups.find(g => Math.abs(g.top - top) <= TOL);
        if (!group) {
          group = { top, cols: [] };
          groups.push(group);
        }
        group.cols.push($col);
      });

      groups.sort((a, b) => a.top - b.top);

      // For each row group, equalise by content item index
      groups.forEach(group => {
        let maxItems = 0;
        group.cols.forEach($col => {
          const count = $col.find(COL_CONTENT_INNER_SELECTOR).length;
          if (count > maxItems) maxItems = count;
        });

        for (let i = 0; i < maxItems; i++) {
          let maxH = 0;
          let heights = [];
          const itemsAtIndex = [];

          group.cols.forEach($col => {
            const $item = $col.find(COL_CONTENT_INNER_SELECTOR).eq(i);
            if ($item.length) {
              $item.css('height', 'auto'); // reset
              const h = $item.outerHeight();
              heights.push(h);
              itemsAtIndex.push({ $item, h });
              if (h > maxH) maxH = h;
            }
          });

          // Only apply if not all equal (within tolerance)
          const allEqual = heights.every(h => Math.abs(h - heights[0]) <= 1);
          if (!allEqual) {
            itemsAtIndex.forEach(({ $item }) => {
              // Apply height to any item but accordion and tabs
              if (!$item.hasClass('qld__accordion-group') && !$item.hasClass('qld__tab-container')) {
                $item.css('height', maxH + 'px');
              }
            });
          }
        }
      });
    }

    function equaliseAll() {
      $(ROW_SELECTOR).each(function () {
        equaliseRow($(this));
      });
    }

    // Run at multiple safe times to cover cached refresh, fonts, etc.
    $(equaliseAll); // DOM ready
    requestAnimationFrame(() => requestAnimationFrame(equaliseAll)); // after first paint
    $(window).on('load', equaliseAll); // after images

    // Webfonts can shift layout after load
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(equaliseAll).catch(() => {});
    }

    // Debounced resize + orientation change
    let resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(equaliseAll, 100);
    }
    $(window).on('resize orientationchange', onResize);

    // ResizeObserver: if available, recalc when a row’s size changes (e.g., breakpoint)
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(() => equaliseAll());
      $(ROW_SELECTOR).each(function () { ro.observe(this); });
    }

    // MutationObserver for dynamically added/removed cards/columns
    const mo = new MutationObserver((mutations) => {
      let touched = new Set();
      mutations.forEach(m => {
        if (m.addedNodes && m.addedNodes.length) {
          $(m.addedNodes).each(function () {
            const $row = $(this).closest(ROW_SELECTOR);
            if ($row.length) touched.add($row[0]);
          });
        }
        if (m.removedNodes && m.removedNodes.length) {
          const $row = $(m.target).closest(ROW_SELECTOR);
          if ($row.length) touched.add($row[0]);
        }
      });
      // Recalc only affected rows
      touched.forEach(node => equaliseRow($(node)));
    });

    $(ROW_SELECTOR).each(function () {
      mo.observe(this, { childList: true, subtree: true });
    });

    // Final safety nets for stubborn late shifts
    setTimeout(equaliseAll, 250);
    setTimeout(equaliseAll, 1000);
  });
})(jQuery, document, window);
